import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  getLayoutHeaderHeight,
  setLayoutValue,
} from "../../features/layouts/layoutsSlice";
import { getLang, setLang } from "../../features/app/UserRelatedSlice";
import { getIsNarrowScreen } from "features/app/UIRelatedSlice";
import {
  IconClose,
  IconMenu,
  IconRight,
  weBridgeLogo,
} from "../../assets/assetReference";
import { backgroundArtArray } from "../../assets/assetReference";

function Header(props: any) {
  const [showMenu, setShowMenu] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const lang = true;
  const isNarrowScreen = useSelector(getIsNarrowScreen);
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");
  const headerHeight = useSelector(getLayoutHeaderHeight);
  const [isHovered, setIsHovered] = useState(false);
  const [whiteBackground, setWhiteBackground] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  const [expandedHeaders, setExpandedHeaders] = useState<{
    [key: string]: boolean;
  }>({});
  const [showExpanded, setShowExpanded] = useState(false);
  const navigate = useNavigate();

  const hideMobileHeader = (e: any) => {
    e.stopPropagation();
    setShowMenu(false);
    setShowExpanded(false);
    setIsHovered(false);
    setExpandedHeaders({});
    if (document.querySelector("html")) {
      document.querySelector("html")!.style.overflow = "visible";
    }
  };

  const toggleMenu = (bool: boolean) => {
    if (document.querySelector("html")) {
      document.querySelector("html")!.style.overflow = bool
        ? "hidden"
        : "visible";
    }
    setShowMenu(bool);
    setExpandedHeaders({});
    setShowExpanded(false);
  };

  function ExpandableHeader({
    title,
    headerKey,
  }: {
    title: any;
    headerKey: string;
  }) {
    return (
      <p
        id={`header-${headerKey}`}
        className={`relative h-full flex gap-1 items-center font-medium hover:cursor-default ${
          isNarrowScreen ? "" : "px-3 py-1 my-3"
        } ${
          currentPath.includes("/" + headerKey) || expandedHeaders[headerKey]
            ? "text-main bg-white/55 rounded-xl"
            : ""
        }`}
        onMouseEnter={
          isNarrowScreen
            ? undefined
            : (e: any) => {
                setExpandedHeaders({
                  services: headerKey === "services",
                  insights: headerKey === "insights",
                });
                setShowExpanded(true);
              }
        }
        onClick={
          !isNarrowScreen
            ? undefined
            : (e: any) => {
                setExpandedHeaders({
                  services: headerKey === "services",
                  insights: headerKey === "insights",
                });
                setShowExpanded(true);
              }
        }
      >
        {lang ? title.en : title.zh}
        {isNarrowScreen && (
          <IconRight width="16" height="16" className="opacity-70" />
        )}
      </p>
    );
  }

  useEffect(() => {
    let resizeTimer: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (headerRef.current && headerRef.current.offsetHeight > 0) {
          dispatch(
            setLayoutValue({
              name: "headerHeight",
              value: headerRef.current.offsetHeight,
            })
          );
        }
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimer) clearTimeout(resizeTimer);
    };
  }, [dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const result =
      (isNarrowScreen && showMenu) ||
      (!isNarrowScreen && showExpanded) ||
      isHovered;
    setWhiteBackground(result);
  }, [isNarrowScreen, showMenu, showExpanded, isHovered]);

  function Headers({ isNarrowScreen }: { isNarrowScreen: boolean }) {
    return (
      <div className={`flex text-sm ${isNarrowScreen ? "flex-col gap-4" : ""}`}>
        <NavLink
          id="header-about-us"
          className={`${
            isNarrowScreen ? "" : "px-3 py-4"
          } hover:text-main  h-full flex items-center ${
            currentPath.includes("/about-us") ? " text-main" : ""
          }`}
          to="/about-us"
          onClick={hideMobileHeader}
        >
          <p className="">{lang ? "About Us" : "关于我们"}</p>
        </NavLink>
        <ExpandableHeader
          title={{ en: "Services", zh: "服务" }}
          headerKey="services"
        />
        <ExpandableHeader
          title={{ en: "Insights", zh: "见解" }}
          headerKey="insights"
        />
        <a
          id="header-gwsce"
          className={`${
            isNarrowScreen ? "" : "px-3 py-4"
          } hover:text-main h-full flex items-center`}
          href="https://www.gwsce.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={hideMobileHeader}
        >
          <p className="">{lang ? "GWSCE" : "伦敦活动"}</p>
        </a>
        <NavLink
          id="header-career"
          className={`${
            isNarrowScreen ? "" : "px-3 py-4"
          } hover:text-main  h-full flex items-center ${
            currentPath.includes("/career") ? " text-main" : ""
          }`}
          to="/career"
          onClick={hideMobileHeader}
        >
          <p className="">{lang ? "Career" : "为我们工作"}</p>
        </NavLink>
        <NavLink
          id="header-contact-us"
          className={`${
            isNarrowScreen ? "" : "px-3 pr-6 py-4"
          } hover:text-main  h-full flex items-center ${
            currentPath.includes("/contact-us") ? " text-main" : ""
          }`}
          to="/contact-us"
          onClick={hideMobileHeader}
        >
          <p className="">{lang ? "Contact Us" : "联系我们"}</p>
        </NavLink>
        {/* <p
          className={`hover:cursor-pointer hover:text-main ${
            isNarrowScreen ? "" : "px-3 pr-6 py-4"
          }`}
          onClick={() => dispatch(setLang(!lang))}
        >
          {lang ? "中文" : "English"}
        </p> */}
      </div>
    );
  }

  const transparentBgHeader =
    currentPath === "/" && !isScrolled && !showMenu && !showExpanded;

  useEffect(() => {
    // Preload images
    const imgServices = new Image();
    imgServices.src = backgroundArtArray.insurers;

    const imgInsights = new Image();
    imgInsights.src = backgroundArtArray.insights;
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0  w-screen z-[9999999999999]  font-medium  
          ${
            transparentBgHeader
              ? "bg-transparent text-white/80"
              : "bg-white border-b text-black/80"
          }
        
        `}
        ref={headerRef}
        onMouseLeave={() => {
          if (isNarrowScreen) return;

          setShowExpanded(false);
          setExpandedHeaders({});
        }}
      >
        {/* Top section - Logo and Navigation */}
        <div className={`${isNarrowScreen ? "py-3 pr-4" : ""} `}>
          <nav className="flex justify-between items-center">
            <NavLink
              id="header-logo"
              to="/"
              className="pl-2 mobile:pl-4 sm:pl-6 hover:cursor-pointer"
              onClick={hideMobileHeader}
            >
              <img
                className={`h-8 opacity-90 object-contain`}
                src={
                  transparentBgHeader ? weBridgeLogo.white : weBridgeLogo.red
                }
                alt="nvfo-logo"
              />
            </NavLink>

            {!isNarrowScreen && <Headers isNarrowScreen={isNarrowScreen} />}

            {isNarrowScreen && (
              <div
                className="hover:cursor-pointer"
                onClick={() => toggleMenu(!showMenu)}
              >
                {showMenu ? (
                  <IconClose height="20" width="20" style={{ fill: "gray" }} />
                ) : (
                  <IconMenu
                    height="20"
                    width="20"
                    style={{ fill: transparentBgHeader ? "white" : "gray" }}
                  />
                )}
              </div>
            )}
          </nav>
        </div>

        {/* Expanded section */}
        <div
          className={`${
            isNarrowScreen ? "flex flex-row justify-between" : ""
          } transition-[height] duration-300 ease-in-out overflow-hidden bg-white border-t shadow-xl shadow-secondary-dark/5 `}
          style={{
            height: !isNarrowScreen
              ? showExpanded
                ? "200px"
                : "0"
              : showMenu
              ? "100vh"
              : "0",
            visibility:
              (!isNarrowScreen && showExpanded) || (isNarrowScreen && showMenu)
                ? "visible"
                : "hidden",
          }}
        >
          {isNarrowScreen && (
            <div className="m-4 mobile:m-10 text-nowrap">
              <Headers isNarrowScreen={isNarrowScreen} />
            </div>
          )}
          <div
            className={`border-b-[0.5px] border-b-gray-300/30 flex gap-4 w-full h-full ${
              isNarrowScreen ? "flex-col" : ""
            }`}
          >
            <div className={`${isNarrowScreen ? "auto" : "h-full"}`}>
              {expandedHeaders["services"] && (
                <div
                  className={`${
                    isNarrowScreen ? "w-full h-[260px]" : "h-full "
                    // : "w-[320px] md:w-[400px] h-full "
                  } relative`}
                  style={{
                    width: isNarrowScreen ? "auto" : "calc(100vw - 29rem)",
                  }}
                >
                  <div className="relative h-full w-full">
                    <img
                      className="h-full w-full object-cover brightness-75"
                      src={backgroundArtArray.insurers}
                      alt="services"
                      loading="eager"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  </div>

                  <p className="font-main-sans absolute bottom-0 left-0 p-4 sm:p-10 text-white flex flex-col gap-2">
                    <span className="text-4xl font-poster">
                      {lang ? "Services" : "服务"}
                    </span>
                    <span className="text-sm font-normal leading-relaxed opacity-70">
                      {lang
                        ? "Explore our services for developers, suppliers, investors, and insurers."
                        : "探索我们为开发者、供应商、投资者和保险公司提供的服务。"}
                    </span>
                  </p>
                </div>
              )}
              {expandedHeaders["insights"] && (
                <div
                  className={`${
                    isNarrowScreen ? "w-full h-[260px]" : "h-full "
                  } relative`}
                  style={{
                    width: isNarrowScreen ? "auto" : "calc(100vw - 24rem)",
                  }}
                >
                  <div className="relative h-full w-full">
                    <img
                      className="h-full w-full object-cover brightness-75"
                      src={backgroundArtArray.insights}
                      alt="insights"
                      loading="eager"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  </div>

                  <p className="font-main-sans absolute bottom-0 left-0 p-4 sm:p-10 text-white flex flex-col gap-2">
                    <span className="text-4xl font-poster">
                      {lang ? "Insights" : "见解"}
                    </span>
                    <span className="text-sm font-normal leading-relaxed opacity-70">
                      {lang
                        ? "Discover our articles, weekly insights, and events."
                        : "发现我们的文章、每周见解和活动。"}
                    </span>
                  </p>
                </div>
              )}
            </div>
            <div
              className={` ${
                isNarrowScreen
                  ? "overflow-y-scroll pt-6 pb-20"
                  : "p-4 pt-5 md:p-10"
              }`}
            >
              {expandedHeaders["services"] && (
                <div
                  className={`flex flex-col gap-2 ${
                    isNarrowScreen ? "mb-20 p-2" : ""
                  } `}
                >
                  {[
                    {
                      to: "/services/for-developers",
                      title: { en: "For Developers", zh: "为开发者" },
                    },
                    {
                      to: "/services/for-suppliers",
                      title: { en: "For Suppliers", zh: "为供应商" },
                    },
                    {
                      to: "/services/for-investors",
                      title: { en: "For Investors", zh: "为投资者" },
                    },
                    {
                      to: "/services/for-insurers",
                      title: { en: "For Insurers", zh: "为保险公司" },
                    },
                  ].map((item, itemIndex) => (
                    <NavLink
                      key={itemIndex}
                      to={item.to}
                      onClick={hideMobileHeader}
                      style={{
                        fontWeight: currentPath.includes(item.to)
                          ? "bold"
                          : "auto",
                      }}
                      className="flex gap-3 items-start hover:opacity-80 hover:cursor-pointer"
                    >
                      <div className="bg-main/10 rounded-md p-2 w-2 mt-1 hover:cursor-pointer">
                        {/* {item.icon} */}
                      </div>
                      <p className="hover:cursor-pointer">
                        {lang ? item.title.en : item.title.zh}
                      </p>
                    </NavLink>
                  ))}
                </div>
              )}
              {expandedHeaders["insights"] && (
                <div
                  className={`flex flex-col gap-2 ${
                    isNarrowScreen ? "mb-20 p-2" : ""
                  } `}
                >
                  {[
                    {
                      to: "/insights/articles",
                      title: { en: "Articles", zh: "文章" },
                    },
                    {
                      to: "/insights/weekly",
                      title: { en: "Weekly", zh: "每周" },
                    },
                    {
                      to: "/insights/events",
                      title: { en: "Events", zh: "活动" },
                    },
                  ].map((item, itemIndex) => (
                    <NavLink
                      key={itemIndex}
                      to={item.to}
                      onClick={hideMobileHeader}
                      className="flex gap-3 items-start hover:opacity-80 hover:cursor-pointer"
                    >
                      <div className="bg-main/10 rounded-md p-2 w-2 mt-1 hover:cursor-pointer">
                        {/* {item.icon} */}
                      </div>
                      <p className="hover:cursor-pointer">
                        {lang ? item.title.en : item.title.zh}
                      </p>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
